import { useEffect, useRef, useState } from 'react';
import brochureJson from '../../Content/Data/Brochure/BrochureMap.json';

function Brochure(props) {

    const [files, setFiles] = useState(null);
    const previewContainerRef = useRef(null);
    const pdfViewerRef = useRef(null);

    useEffect(() => {
        loadData();
    }, [props.isPathChanged]);

    const loadData = async () => {
        try {
            const fileData = await import(`../../Content/Data/Brochure/${brochureJson["FullName"]}`);
            const file = {
                ["FileKey"]: fileData.default
            };
            setFiles(file);
        } catch (error) {
            console.error("Failed to load brochure files:", error);
        }
    };

    const handlePreview = () => {
        pdfViewerRef.current.src = files["FileKey"] + "#toolbar=0";
        previewContainerRef.current.style.display = "block";
    };

    const handleClosePreview = () => {
        pdfViewerRef.current.src = null;
        previewContainerRef.current.style.display = "none";
    }

    const handleDownload = () => {
        const a = document.createElement('a')
        a.href = files["FileKey"];
        a.download = brochureJson["FullName"]
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a);
    };

    return (
        <div className="brochure">
            <div className="brochure-side-pane" onClick={() => { handlePreview(); }}>
                <span className='brochure-side-pane-text'>Our Brochure</span>
            </div>
            <div className="brochure-preview-container" ref={previewContainerRef}>
                <div className='brochure-preview-controls-container'>
                    <i class="fa fa-download brochure-preview-control pointer" aria-hidden="true" onClick={() => { handleDownload(); }} />
                    <i class="fa fa-close brochure-preview-control pointer" aria-hidden="true" onClick={() => { handleClosePreview(); }} />
                </div>
                <div className='brochure-preview-viewer-container'>
                    <embed ref={pdfViewerRef} width="100%" height="100%" />
                </div>
            </div>
        </div>
    );
}

export default Brochure;
